import { FlaskConical, BookOpen, Bus, Home, GraduationCap, Presentation } from "lucide-react";

const ITEMS = [
    {
        icon: FlaskConical,
        title: "Modern Laboratories",
        body: "Pharmaceutics, pharmacology, and analytical labs equipped for hands-on practice and PCI-aligned protocols.",
        accent: "green",
    },
    {
        icon: BookOpen,
        title: "Library & e-Resources",
        body: "Curated pharmacy texts, journals and digital references — built for deep, exam-ready study.",
        accent: "blue",
    },
    {
        icon: Presentation,
        title: "Smart Classrooms",
        body: "Bright, ventilated rooms with audio-visual aids that make complex pharmacology come alive.",
        accent: "green",
    },
    {
        icon: Bus,
        title: "Transport",
        body: "Reliable college transport from key pickup points across Mallarpur and Birbhum for safe daily commute.",
        accent: "blue",
    },
    {
        icon: Home,
        title: "Hostel Facility",
        body: "Comfortable, supervised hostel residence — a safe second home for outstation students.",
        accent: "green",
    },
    {
        icon: GraduationCap,
        title: "Scholarships & SCC",
        body: "Government scholarships and Students&rsquo; Credit Card support to keep education accessible to all.",
        accent: "blue",
    },
];

export const WhyChoose = () => (
    <section
        id="facilities"
        data-testid="facilities-section"
        className="relative py-24 lg:py-32 bg-gradient-to-b from-[var(--bg-page)] to-stone-100/60"
    >
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
            <div className="text-center max-w-2xl mx-auto reveal">
                <span className="section-rule eyebrow mx-auto">Why Choose Us</span>
                <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[1.05] text-stone-900">
                    Facilities designed for <em className="not-italic text-[var(--brand-green)]">serious</em> pharmacy learners.
                </h2>
                <p className="mt-5 text-stone-600 text-base md:text-lg leading-relaxed">
                    From practical labs to a quiet library and supportive hostel life — every facility is
                    crafted to help you focus on what matters: becoming an exceptional pharmacist.
                </p>
            </div>

            <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
                {ITEMS.map(({ icon: Icon, title, body, accent }, i) => (
                    <div
                        key={title}
                        data-testid={`facility-card-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        className={`tactile-card p-7 md:p-8 reveal delay-${(i % 5) + 1}`}
                    >
                        <div
                            className="w-12 h-12 rounded-xl flex items-center justify-center mb-5"
                            style={{
                                background:
                                    accent === "green"
                                        ? "rgba(27, 122, 62, 0.10)"
                                        : "rgba(30, 107, 191, 0.10)",
                                color: accent === "green" ? "var(--brand-green)" : "var(--brand-blue)",
                            }}
                        >
                            <Icon size={22} />
                        </div>
                        <h3 className="font-display text-2xl text-stone-900">{title}</h3>
                        <p
                            className="mt-3 text-sm md:text-[15px] text-stone-600 leading-relaxed"
                            dangerouslySetInnerHTML={{ __html: body }}
                        />
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default WhyChoose;
